// import React from 'react';
// import AnchorLink from 'react-anchor-link-smooth-scroll'
// import './style.css'

// const Scrollbar = () => {

//     return(
//         <div className="col-lg-12">
//             <div className="header-menu">
//                 <ul className="smothscroll">
//                     <li><AnchorLink href='#scrool'><i className="ti-arrow-up"></i></AnchorLink></li>
//                 </ul>
//             </div>
//         </div>
        
//     )
// }

// export default Scrollbar;

// scroll component is modified into whats app component 
import React from 'react';
import './style.css';

const Scrollbar = () => {
  return (
    <a
      href="https://wa.me/917845827718?text=Hi,%20i%20would%20like%20to%20contact%20you"
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <span className="whatsapp-circle" aria-hidden="true">
        {/* --- CORRECTED SVG --- */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          className="whatsapp-svg"
          preserveAspectRatio="xMidYMid meet"
        >
          <path
            fill="currentColor"
            d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.8 0-67.3-8.8-98.1-25.4l-7-4.1-73.3 19.2 19.6-71.2-4.6-7.4c-18.7-29.9-28.7-64.9-28.7-101.5 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
          />
        </svg>
        {/* --- END CORRECTED SVG --- */}
      </span>
    </a>
  );
};

export default Scrollbar;
